import { render, staticRenderFns } from "./TabContainer.vue?vue&type=template&id=6d5f7c66&scoped=true&"
import script from "./TabContainer.vue?vue&type=script&lang=js&"
export * from "./TabContainer.vue?vue&type=script&lang=js&"
import style0 from "./TabContainer.vue?vue&type=style&index=0&id=6d5f7c66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5f7c66",
  null
  
)

export default component.exports